import React from "react";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import { useQuery } from "@apollo/client";
import { GET_DIAMS_WITH_IMAGE, tokenOptions } from "../../backend/graphql";
import { byCalibration } from "../../backend/calibration";
import DiamondAnalysisView from "./DiamondAnalysisView";
import useDocumentTitle, { stoneName } from "../widgets/useDocumentTitle";

const AnalysisFromDiamond = () => {
  const { id } = useParams();
  const token = useAppSelector((state) => state.auth.token);
  const { loading, error, data } = useQuery(GET_DIAMS_WITH_IMAGE, {
    ...tokenOptions(token),
    variables: { take: 100, skip: 0, filter: 'iD == "' + id + '"' },
  });

  useDocumentTitle(
    stoneName(data?.diamonds?.items[0]),
    "Image analysis",
  );

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;
  if (!id) return <p>Not found!</p>;

  const diamond = data?.diamonds?.items[0];
  // The picture to analyse: sorted so the original comes first when the stone has one.
  const image = [...(diamond?.images ?? [])].sort(byCalibration)[0];

  return <DiamondAnalysisView diamond={diamond} image={image} />;
};

export default AnalysisFromDiamond;
